/** Where in the back-office a file was dropped (`dossier_files.origin`). */
export type DossierFileOrigin = "contact" | "message" | "qualification";

/**
 * A file the team attached to a contact — the first brick of the dossiers
 * (`backend/src/services/dossiers/docs/DOSSIERS.md`).
 */
export type DossierFile = {
  id: string;
  client_id: string;
  customer_id: string;
  filename: string;
  content_type: string;
  size: number;
  uploaded_by_name: string;
  origin: DossierFileOrigin;
  origin_id: string;
  created_at: number;
  created_by: string;
};

/** The screen an upload comes from, recorded on the file. */
export type DossierFileSource = { origin: DossierFileOrigin; originId?: string };

/** Mirrors `MAX_FILE_BYTES` in `dossiers/routes.ts`. */
export const MAX_DOSSIER_FILE_BYTES = 20 * 1024 * 1024;
